import React from "react";
import { useRequest } from "hooks";
import classNames from "classnames";
import { generatePath } from "utils";
import { endpoints } from "configs";
import { UserSchool } from "types";
import { Button, Icon, MenuItem, Spinner, Typography } from "components";
import { getRoute } from "pages/teacher/utils";
import navStyles from "../../UserNav.module.css";
import styles from "./School.module.css";

interface SchoolType {
  school: UserSchool;
  current: boolean;
  teacherDefaultHomeRoute: any;
}

const School: React.FC<SchoolType> = ({
  school,
  current,
  teacherDefaultHomeRoute,
}) => {
  const [{ loadingCount }, fetch] = useRequest({
    url: `${generatePath(endpoints.switchSchool)}?subinstall=${school.subinstall}`,
  });

  const handleClick = (): void => {
    if (!current) {
      fetch().then((result) => {
        localStorage.setItem("token", result.data.data.authToken);
        window.location.replace(getRoute(teacherDefaultHomeRoute || "home"));
      });
    }
  };

  return (
    <MenuItem className={navStyles.item}>
      <Button
        onClick={handleClick}
        className={classNames(navStyles.link, styles.school, {
          [styles.activeButton]: current,
        })}
      >
        <Typography
          className={classNames(styles.name, { [styles.active]: current })}
          variant="c1"
          component="span"
        >
          {school.schoolName}
        </Typography>
        {current && (
          <Icon
            name="check-circle-outlined"
            size="small"
            className={styles.selectedIcon}
          />
        )}
        {loadingCount > 0 && (
          <Spinner size="small" className={styles.spinner} />
        )}
      </Button>
    </MenuItem>
  );
};

export default School;
